import { setCookie, getCookie } from '../cookie';

export default class MailMember {

  generateAIMessage(trigger = '') {
    var overlay = document.getElementById('ai-generate-overlay');
    if (overlay) overlay.style.display = 'block';

    fetch('https://' + gon.api_domain + '/v1/chatgpt/resume_summary_for_company?trigger=' + trigger, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        work_history_ids: document.getElementById('work_history_ids').value,
        summary_length: document.getElementById('summary_length').value,
        extra_instructions: document.getElementById('extra_instructions').value,
        member_id: gon.member_id,
        site_lang: gon.locale,
        lang: gon.locale,
        company_id: document.getElementById('company_id').value,
        company_user_id: document.getElementById('company_user_id').value
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      document.getElementById('ai-generated-text').value = data.message;
      var aiGenTextFront = document.getElementById('ai-generated-text-front');
      aiGenTextFront.textContent = data.message;
      aiGenTextFront.classList.remove('blink');
      document.getElementById('copy-to-clipboard-btn').classList.remove('d-none');
    })
    .catch(() => {
      document.getElementById('ai-generated-text').value = gon.generate_failed;
    })
    .finally(() => {
      if (overlay) overlay.style.display = 'none';
    });
  };

  callCopyToClipboard(trigger = '') {
    var aiGenTextFront = document.getElementById('ai-generated-text-front');
    navigator.clipboard.writeText(aiGenTextFront.textContent);

    fetch('https://' + gon.api_domain + '/v1/chatgpt/copy_to_clipboard_for_company?trigger=' + trigger, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        company_id: document.getElementById('company_id').value,
        company_user_id: document.getElementById('company_user_id').value,
        member_id: gon.member_id,
        lang: gon.locale,
        text: aiGenTextFront.textContent
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      // do nothing
    })
    .catch(error => {
      console.error('Failed to call copy_to_clipboard_for_company:', error);
    });

    if (!Cookie.getCookie('ai_copy_dialog_shown')) {
      Cookie.setCookie('ai_copy_dialog_shown', '1', 7);
      alert(window.AI_GENERATED_TEXT_PLACEHOLDER.replace(/&#39;/g, "'"));  // about replace, might be better way
    }
  };


  openAIGenerateModal() {
    var modal = document.getElementById('ai-generate-modal');
    modal.style.display = 'block';
    modal.classList.add('show');
    document.body.classList.add('modal-open');
    // Add backdrop
    var backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    backdrop.id = 'ai-generate-backdrop';
    document.body.appendChild(backdrop);

    fetch('https://' + gon.api_domain + '/v1/chatgpt/open_resume_summary_dialog/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        company_id: document.getElementById('company_id').value,
        company_user_id: document.getElementById('company_user_id').value,
        member_id: gon.member_id,
        lang: gon.locale,
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      // do nothing
    })
    .catch(error => {
      console.error('Failed to call open_resume_summary_dialog:', error);
    });
  }

  closeAIGenerateModal() {
    var modal = document.getElementById('ai-generate-modal');
    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.classList.remove('modal-open');
    // Remove backdrop
    var backdrop = document.getElementById('ai-generate-backdrop');
    if (backdrop) backdrop.remove();
  }

  copyGeneratedText() {
    var textarea = document.getElementById('ai-generated-text');
    var feedback = document.getElementById('copy-feedback');
    if (textarea && feedback) {
      navigator.clipboard.writeText(textarea.value).then(function() {
        feedback.textContent = gon.copy_success;
        feedback.className = 'align-middle ml-3 mt-1';
        feedback.style.visibility = 'visible';
        setTimeout(function() {
          feedback.style.visibility = 'hidden';
        }, 3000);
      }).catch(function(err) {
        feedback.textContent = gon.copy_failed;
        feedback.className = 'alert alert-danger mt-2';
        feedback.style.visibility = 'visible';
        console.error('Unable to copy text: ', err);
        setTimeout(function() {
          feedback.style.visibility = 'hidden';
        }, 2000);
      });
    }
  }

  setupEventListeners() {

    window.addEventListener('DOMContentLoaded', function() {
      var select_length = document.getElementById('summary_length');
      if (select_length) {
        // 初期表示時にCookieから値をセット
        var saved = Cookie.getCookie('ai_summary_length');
        if (saved) {
          for (var i = 0; i < select_length.options.length; i++) {
            if (select_length.options[i].value === saved) {
              select_length.selectedIndex = i;
              break;
            }
          }
        }
        select_length.addEventListener('change', function() {
          Cookie.setCookie('ai_summary_length', select_length.value, 365);
        });
      }

      var openGenerateBtn = document.getElementById('ai-generate-btn');
      if (openGenerateBtn) {
        openGenerateBtn.addEventListener('click', () => mailMember.openAIGenerateModal());
      }

      var copyBtnDialog = document.getElementById('copy-to-clipboard-btn-dialog');
      if (copyBtnDialog) {
        copyBtnDialog.addEventListener('click', () => mailMember.callCopyToClipboard(''));
      }

      var copyBtn = document.getElementById('copy-to-clipboard-btn');
      if (copyBtn) {
        copyBtn.addEventListener('click', () => mailMember.callCopyToClipboard('auto'));
      }

      var genereteTextBtn = document.getElementById('btn_generate_text');
      if (genereteTextBtn) {
        mailMember.generateAIMessage('auto');
      }
    });
  }
}

const mailMember = new MailMember();
mailMember.setupEventListeners();
